module.exports = __webpack_public_path__ + "img/talent3.6794a4ea.jpg";